module.exports = __webpack_public_path__ + "img/files.ac0d6605.svg";